import WebApp from "@twa-dev/sdk";
import type { Platforms } from "@twa-dev/types";

const TG_PLATFORMS_DESKTOP: Platforms[] = ["macos", "tdesktop"];

export function webAppIsDesktop(): boolean {
  return TG_PLATFORMS_DESKTOP.includes(WebApp.platform);
}
